import React from "react";
import userDate from "../../userdata.json";
import LangSvg from "../../images/languages";

function Skills() {
  const { skills } = userDate || {};
  return (
    <div id="Skills" className="pt6">
      <div className=" f1 mb5 flex">
        <hr className="w-50" />
        <span className="mh3">Skills</span>
        <hr className="w-50" />
      </div>

      {(skills || []).map((types) => (
        <div className="mt4-l mt3 flex flex-wrap justify-center">
          {(types?.skills || []).map((skill) => (
            <div className="pv4-l ph5-l pa2 ph3 flex pointer br3 flex-column langs justify-center items-center  glassmorphic-3 ml3 mb3">
              <LangSvg lang={skill?.value} className="w3-l h3-l h2 w2" />
              <div className="mt3-l mt2 f6 f5-l">{skill?.label}</div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

export default Skills;
